import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
var useSuggestedNextSteps = function useSuggestedNextSteps(workspace_id, patient_id) {
  var url = "/workspaces/".concat(workspace_id, "/patient/").concat(patient_id, "/suggest_next_steps/");
  return useMutation(function (params) {
    return servicesUtils.postService(url, params);
  });
};
export default useSuggestedNextSteps;